module.exports = __webpack_public_path__ + "img/ape-constructor-clock.a142bb43.svg";